<template>
  <section :class="prefixCls" class="mt-3">
    <ContainerCard>
      <div class="content-box flex flex-col items-center">
        <slot name="header">
          <SvgIcon name="exchangeservice-member_frame" size="233" />
        </slot>
        <section class="text-content w-197 px-3 my-4">
          <span class="title-box inline-block my-3">{{ t('会员资质说明') }}</span>
          <TypographyParagraph>
            Guided by regulatory requirement in Macao, we are currently open to Regulated Financial
            Institutions to become MCEX members in compliance with onboarding requirements,
            including KYC / AML checks. Eligibility criteria as below:<br />
            · A regulated financial institution that carries on the business of the provision of
            investment services in Macao or other jurisdictions<br />
            · A regulated banking institution in Macao or other jurisdictions<br />
            · A regulated insurance company in Macao or other jurisdictions<br />
            · A regulated pension fund management company in Macao or other jurisdictions<br />
            · A regulated collective investment scheme in Macao or other jurisdictions
          </TypographyParagraph>
          <span class="title-box inline-block my-3">{{ t('会员权利') }}</span>
          <TypographyParagraph>
            ·Trading rights on DROs / MCEX approved DRO-related products and direct participation in
            AOs / SOs<br />
            ·Access to daily store data in accordance with disclosure rules<br />
            ·Access to proprietary industry reports1<br />
            ·Access to data / investment analytical tools 1<br />
            ·Access to investor financing solutions
          </TypographyParagraph>
        </section>
        <slot name="extra">
          <BecomeMember
            preIcon="M-terminal-iconvip|alisvg"
            type="primary"
            class="mt-1 !py-3 !h-10.5"
          />
        </slot>
      </div>
    </ContainerCard>
  </section>
</template>

<script setup lang="ts">
  import { useDesign } from '/@/hooks/web/useDesign';
  import { useI18n } from '@mcex/locale';
  import { SvgIcon } from '/@/components/Icon';
  import { ContainerCard } from '/@/components/Business/Card';
  import { TypographyParagraph } from 'ant-design-vue';
  import BecomeMember from '/@/layouts/default/menu/components/BecomeMember.vue';

  const { t } = useI18n();
  const { prefixCls } = useDesign('register-home-box');
</script>

<style lang="less" scoped>
  @prefix-cls: ~'@{namespace}-register-home-box';

  .@{prefix-cls} {
    @height: calc(100vh - @right-top - (@first-card-spacing*2));

    .content-box {
      height: @height;
    }

    .text-content {
      border-radius: @first-card-radius;
      border: 1px solid var(--color-card, #2f333a);
    }

    .title-box {
      padding: 5px 16px;
      border-radius: 4px;
      border: 1px solid var(--primary-color-2, #45bfb0);
    }
  }
</style>
